import React, { useState } from 'react';

//material
import { makeStyles } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { currency, nPercent } from 'hooks/Pipe';
import { Visibility } from '@material-ui/icons';
import Button from 'components/CustomButtons/Button.js';
import { WithApp } from 'contexts/appContext';
import Modal from '../Modal/ModalndexPaymentTerm';

import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    '& h6': {
      fontSize: 13,
      color: theme.palette.text.secondary,
      margin: 0
    },
    '& h5': {
      fontSize: 15,
      fontWeight: 400,
      margin: 0
    },
    marginBottom: '15px'
  }
}));

export default WithApp(function Read(props) {
  const classes = useStyles();
  const { bPartner, showNotify, reload } = props; //datos de socio
  const [open, setOpen] = useState(false);

  return (
    <>
      <Modal
        open={open}
        setOpen={setOpen}
        showNotify={showNotify}
        bPartner={bPartner}
        reload={reload}
      />

      <GridContainer>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>% Retraso</h6>
          <h5>{nPercent(bPartner.IntrstRate)}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Lista precio</h6>
          <h5>{bPartner.ListName || '-'}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>% Descuento</h6>
          <h5>{nPercent(bPartner.Discount)}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Línea crédito</h6>
          <h5>
            {currency(bPartner.CreditLine)}
            {bPartner.CardType === 'C' ? (
              <AllowedGuard
                permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ACCOUNTING_CREDIT_LINE_SHOW}
              >
                <Button
                  justIcon
                  round
                  simple
                  color={props.themeContext.buttonColor}
                  size="sm"
                  className={classes.marginRight}
                  onClick={() => {
                    setOpen(true);
                  }}
                  disabled={bPartner.GroupNum == '-1'}
                >
                  <Visibility className={classes.icons} />
                </Button>
              </AllowedGuard>
            ) : undefined}
          </h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Término pago</h6>
          <h5>{bPartner.PymntGroup || '-'}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Línea comprometido</h6>
          <h5>{currency(bPartner.DebtLine)}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Grupo desc.</h6>
          <h5>
            {bPartner.DiscRel === 'L'
              ? 'Desc. + bajo'
              : bPartner.DiscRel === 'H'
              ? 'Desc. + alto'
              : bPartner.DiscRel === 'A'
              ? 'Promedio'
              : bPartner.DiscRel === 'S'
              ? 'Total'
              : bPartner.DiscRel === 'M'
              ? 'Múltiples Desc.'
              : '-'}
          </h5>
        </GridItem>
        {/* Grupo 2 */}
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Precio efectivo</h6>
          <h5>
            {bPartner.EffecPrice === 'L'
              ? 'Precio + bajo'
              : bPartner.EffecPrice === 'H'
              ? 'Precio + alto'
              : bPartner.EffecPrice === 'D'
              ? 'Precio x defecto'
              : '-'}
          </h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>País</h6>
          <h5> {bPartner.HousBnkCry || '-'}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Banco</h6>
          <h5> {bPartner.HouseBank || '-'}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Cuenta</h6>
          <h5> {bPartner.HousBnkAct || '-'}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Indicador Impuestos</h6>
          <h5> {bPartner.VatGroup || '-'}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Tipo Inpuesto</h6>
          <h5>
            {' '}
            {bPartner.VatStatus === 'Y'
              ? 'Obligatorio'
              : bPartner.VatStatus === 'N'
              ? 'Extranjero'
              : '-'}
          </h5>
        </GridItem>
        {/* Grupo 3 */}
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>SN Agente Percepción</h6>
          <h5> {bPartner.U_SYP_TPER === 'Y' ? 'Si' : bPartner.U_SYP_TPER === 'N' ? 'No' : '-'}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>SN de Retención</h6>
          <h5>
            {bPartner.U_SYP_AGENRE === 'Y' ? 'Si' : bPartner.U_SYP_AGENRE === 'N' ? 'No' : '-'}
          </h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>SN Buen Contribuyente</h6>
          <h5>
            {bPartner.U_SYP_SNBUEN === 'Y' ? 'Si' : bPartner.U_SYP_SNBUEN === 'N' ? 'No' : '-'}
          </h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>SN Exonerado de Percepción</h6>
          <h5>
            {bPartner.U_SYP_EXOPER === 'Y' ? 'Si' : bPartner.U_SYP_EXOPER === 'N' ? 'No' : '-'}
          </h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Balance</h6>
          <h5> {currency(bPartner.Balance)}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Comentarios</h6>
          <h5> {bPartner.Free_Text || '-'}</h5>
        </GridItem>
        <GridItem xs={12} sm={4} md={4} lg={2} className={classes.paper}>
          <h6>Cuenta deudores / Pago a proveedores</h6>
          <h5> {bPartner.DebPayAcct || '-'}</h5>
        </GridItem>
      </GridContainer>
    </>
  );
});
